import {
  LabelBinding,
  RequestDataOfCreateSessionRequest,
  ResponseDataOfCreateSessionResponse,
} from '@monorepo-types/dc/smartthermostat';

import { request } from '../../client';
import type { ApiRequestConfig } from '../../client/types';

type CreateSession = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  locationId: string;
  masterId: string;
  requestBody: RequestDataOfCreateSessionRequest;
};
/**
 *
 *
 * @returns ResponseDataOfCreateSessionResponse OK
 */
export function createSession(
  { businessUnit, label, customerId, accountId, locationId, masterId, requestBody }: CreateSession,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfCreateSessionResponse> {
  return request(
    {
      method: 'POST',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/locations/${locationId}/hosts/${masterId}/sessions`,
      body: requestBody,
      errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found',
        412: 'Precondition Failed',
        500: 'Internal Server Error',
      },
    },
    requestConfig,
  );
}
